import { getDatePartsInAppTimezone, startOfDayInAppTimezone, } from '@/shared/utils/app-timezone';
/** Today 00:00 Kabul → now (ISO strings for API query params). */
export function todayAgentStatisticsDateRange() {
    const today = getDatePartsInAppTimezone(new Date());
    const start = startOfDayInAppTimezone(today);
    return {
        dateFrom: start.toISOString(),
        dateTo: new Date().toISOString(),
    };
}
export function formatAgentStatisticsMinutes(minutes) {
    return `${Math.max(0, Math.round(minutes))}m`;
}
export function agentStatisticsInfoRows(stats) {
    return [
        { label: 'Agent Name', value: stats.agentName || '—' },
        { label: 'Agent Company', value: stats.company || '—' },
        { label: 'Username', value: stats.username || '—' },
        { label: 'Answered Calls', value: String(stats.answeredCalls) },
        { label: 'Missed Calls', value: String(stats.missedCalls) },
        { label: 'Received Calls', value: String(stats.receivedCalls) },
        { label: 'Login Time', value: stats.loginTime ? stats.loginTime : '—' },
    ];
}
export function agentStatisticsActivityRows(activity) {
    return [
        { label: 'Answered Calls', numeric: activity.answeredCalls, display: String(activity.answeredCalls) },
        { label: 'Received Calls', numeric: activity.receivedCalls, display: String(activity.receivedCalls) },
        { label: 'Missed Calls', numeric: activity.missedCalls, display: String(activity.missedCalls) },
        {
            label: 'Break Duration',
            numeric: activity.breakDurationMinutes,
            display: formatAgentStatisticsMinutes(activity.breakDurationMinutes),
        },
        {
            label: 'Talk Time',
            numeric: activity.talkTimeMinutes,
            display: formatAgentStatisticsMinutes(activity.talkTimeMinutes),
        },
        {
            label: 'Idle Time',
            numeric: activity.idleTimeMinutes,
            display: formatAgentStatisticsMinutes(activity.idleTimeMinutes),
        },
        {
            label: 'Busy Time',
            numeric: activity.busyTimeMinutes,
            display: formatAgentStatisticsMinutes(activity.busyTimeMinutes),
        },
    ];
}
